import { FC, ReactNode } from 'react'

type IErrorLabel = {
  children?: ReactNode
  className?: string
}

export const ErrorLabel: FC<IErrorLabel> = ({ children, className = '' }) => (
  <div className={`invalid-feedback d-block ${className}`}>
    <span role='alert'>{children}</span>
  </div>
)
